import {atomWithStorage} from "jotai/utils";

export const createFormAtom = atomWithStorage('request', {
    formTypeId: '',
    categoryId: 0,
    formValues: [],
    pNumber:''
})